// ============================================================================
// Shared Constants for Wizard Components
// ============================================================================

// ── Color Primitives ────────────────────────────────────────────────────────
// Each hex value appears exactly once here; everything else references these.

const RED = "#FF0000";
const ORANGE = "#FF8C00";
const YELLOW = "#FFD700";
const GREEN = "#33CC33";
const TEAL = "#00CED1";
const BLUE = "#2196F3";
const PURPLE = "#9C27B0";
const PINK = "#EC407A";
const BROWN = "#8B4513";
const GRAY = "#9E9E9E";

const DARK_RED = "#B71C1C";
const CORAL = "#FF6B6B";
const AQUA = "#4ECDC4";
const WHITE = "#FFFFFF";
const CHARCOAL = "#666666";
const ELECTRIC_BLUE = "#2979FF";

// ── Palettes ────────────────────────────────────────────────────────────────

/** Color palette for different job boundaries on the map */
export const BOUNDARY_COLORS = [RED, TEAL, GREEN, YELLOW, BROWN, GRAY, PINK, BLUE, ORANGE, PURPLE];

/** Color palette for distinguishing duplicate features within a group */
export const DUPLICATE_GROUP_COLORS = [...BOUNDARY_COLORS].reverse();

/** Human-readable names matching DUPLICATE_GROUP_COLORS order */
export const DUPLICATE_GROUP_COLOR_NAMES = [
	"Purple",
	"Orange",
	"Blue",
	"Pink",
	"Gray",
	"Brown",
	"Yellow",
	"Green",
	"Teal",
	"Red",
];

// ── Semantic Colors ─────────────────────────────────────────────────────────

/** Color for nearby jobs (grayed out) */
export const NEARBY_JOB_COLOR = GRAY;

/** Color for highlight/intersection areas */
export const HIGHLIGHT_COLOR = RED;

/** Stroke color for highlighted intersections */
export const HIGHLIGHT_STROKE_COLOR = DARK_RED;

/** Color for unmatched point features */
export const UNMATCHED_POINT_COLOR = CORAL;

/** Color for unmatched zone features */
export const UNMATCHED_ZONE_COLOR = AQUA;

/** Color/style for the overlap/intersection area */
export const OVERLAP_FILL_COLOR = WHITE;
export const OVERLAP_STROKE_COLOR = CHARCOAL;

/** Color for selected features on the map (unmatched feature selection) */
export const SELECTED_COLOR = ELECTRIC_BLUE;

/** Opacity for selected features */
export const SELECTED_OPACITY = 0.6;

/** Lasso tool stroke/fill color */
export const LASSO_COLOR = BLUE;

// ── Map Defaults ────────────────────────────────────────────────────────────

/** Default map container height */
export const DEFAULT_MAP_HEIGHT = "300px";

/** Default map center (Illinois) */
export const DEFAULT_CENTER = { lat: 40.0, lng: -89.0 };

/** Angles (degrees) for hatch lines on boundary polygons. Adjacent boundaries are 90° apart. */
export const HATCH_ANGLES = [45, 135, 0, 90, 22.5, 112.5, 67.5, 157.5];

/** Spacing between hatch lines in meters */
export const HATCH_LINE_SPACING_METERS = 40;
